<template>
  <div class="whs-detail-hotel-amenities">
    <div class="whs-amenities-title">Все услуги и удобства</div>
    <div class="whs-amenities-container">
      <div class="whs-amenity-group" v-for="amenity in amenities" :key="amenity.group_slug">
        <div
          class="whs-amenity-group-title whs-icon-left whs-icon-amenity"
          :class="amenityIcon(amenity.group_slug)"
        >{{ amenity.group_name }}</div>
        <div class="whs-amenity-group-item" v-for="item in amenity.amenities" :key="item">{{ item }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Amenitites',
  props: {
    amenities: {
      type: Array,
      required: true
    }
  },
  methods: {
    amenityIcon(amenity) {
      return 'whs-icon-' + amenity;
    }
  }
};
</script>

<style scoped>
.whs-detail-hotel-amenities {
  margin: 24px 0;
  padding: 8px 0;
  background-color: #fff;
  border-radius: 4px;
  -webkit-box-shadow: 0 0 1px var(--color-text-5), 0 0 8px var(--color-bg-dark);
  box-shadow: 0 0 1px var(--color-text-5), 0 0 8px var(--color-bg-dark);
}
.whs-amenities-title {
  font-size: 24px;
  padding: 8px 18px;
}
.whs-amenities-container {
  columns: 210px 3;
}
.whs-amenity-group {
  break-inside: avoid;
  padding: 18px;
}
.whs-amenity-group-title {
  font-size: 16px;
  font-weight: 500;
}
.whs-amenity-group-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  padding: 4px;
  line-height: 15px;
}
.whs-amenity-group-item:before {
  content: '';
  margin: 0 14px 0 10px;
  flex: 0 0 3px;
  height: 3px;
  background-color: var(--color-bg);
  border: 2px solid var(--color-bg-dark);
  border-radius: 3px;
}
.whs-icon-amenity:before {
  font-size: 18px;
  width: 20px;
  display: inline-block;
  color: var(--color-alt-5);
  text-align: right;
  content: '\f04b';
}
.whs-icon-has_common_info:before {
  content: '\f594';
}
.whs-icon-has_internet:before {
  content: '\f1eb';
}
.whs-icon-has_meal:before {
  content: '\f2e7';
}
.whs-icon-has_kids:before {
  content: '\f1ae';
}
.whs-icon-has_parking:before {
  content: '\f540';
}
.whs-icon-has_pets:before {
  content: '\f6d3';
}
.whs-icon-has_disabled_support:before {
  content: '\f193';
}
.whs-icon-has_pool:before {
  content: '\f5c5';
}
.whs-icon-has_fitness:before {
  content: '\f44b';
}
.whs-icon-has_languages:before {
  content: '\f1ab';
}
.whs-icon-has_entertainment:before {
  content: '\f6e8';
}
.whs-icon-has_extra_service:before {
  content: '\f236';
}
.whs-icon-has_extra_services:before {
  content: '\f562';
}
.whs-icon-has_busyness:before {
  content: '\f685';
}
.whs-icon-has_barber_shop:before {
  content: '\f5bb';
}
.whs-icon-has_tours:before {
  content: '\f59f';
}
.whs-icon-has_shuttle:before {
  content: '\f5b6';
}
</style>